// extracted by mini-css-extract-plugin
export var button = "_d2-4";
export var hasDarkBackground = "_d2-7";
export var hasLightBackground = "_d2-6";
export var iconWrapper = "_d2-0";
export var large = "_d2-2";
export var medium = "_d2-1";
export var small = "_d2-5";
export var xsmall = "_d2-3";